:host {
  --bg-smoke-light: rgba(0, 0, 0, 0.5);
  margin-left: 20px;
  font-family: var(--ai12z-search-font-family) var(--ai12z-font-family) !important;
  font-size: var(--ai12z-search-font-size, var(--ai12z-font-size)) !important;
}

ai12z-category {
  font-family: var(--ai12z-font-family) !important;
  font-size: var(--ai12z-search-font-size, var(--ai12z-font-size)) !important;
}

.bg-smoke-light {
  /* background-color: var(--bg-smoke-light); */
  transition: opacity 300ms ease-in-out;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  display: flex;
  height: 100vh;
  width: 100vw;
  cursor: auto;
  flex-direction: column;
  background-color: #0003;
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate)
    var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.modal-content {
  transition:
    transform 300ms ease-in-out,
    opacity 300ms ease-in-out;
  transform: scale(0.9);
  opacity: 0;
}

.modal-position {
  position: relative;
  padding: 2rem 1rem 0.5rem 1rem;
  flex-direction: column;
}

.modal-close {
  color: rgb(0 0 0);
}

.modal-close:hover {
  color: rgb(31 41 55);
}

.model-heading {
  color: var(--ai12z-heading-color);
  font-size: var(--ai12z-heading-font-size);
}

:host(.show-modal) .bg-smoke-light {
  opacity: 1;
}

:host(.show-modal) .modal-content {
  transform: scale(1);
  opacity: 1;
}

.modal-content-wrapper {
  /* padding: 2rem; */ /* 32 px */
  background-color: rgb(255 255 255);
  width: 100%;
  max-width: 48rem; /* 768px */
  /* margin: auto; */
  /* flex-direction: column; */
  border-radius: 0.5rem; /* 8px */
  margin: var(--ai12z-dialog-margin); /* 48px */
}
.custom-title {
  font-size: var(--ai12z-category-font-size);
  color: var(--ai12z-category-font-color);
}
.model-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  display: flex;
  height: 100vh;
  width: 100vw;
  cursor: auto;
  flex-direction: column;
  background-color: #0003;
  padding: 1rem;
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate)
    var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate)
    var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.custom-model {
  overflow: auto;
  /* flex: none; */
  inset: 0px;
  position: fixed;
  min-height: 100vh;
  /* justify-content: center; */
  place-items: center;
  display: flex;
}

.modal-position .btn-position {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 0.25rem;
}

@media (max-width: 768px) {
  /* Styles for tablets and mobile phones */
  .modal-content-wrapper {
    width: 100%;
    height: 100dvh;
    margin: 0;
    border-radius: 0;
    padding: 1rem;
  }
  .custom-privacy {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px;
  }
  .modal-position .btn-position {
    padding: 0rem;
  }
}

.custom-privacy {
  color: var(--ai12z-knowledge-box-privacy-color);
  text-align: center;
  /* margin-top: 10px; */
  margin-top: auto; /* Pushes the footer to the bottom */
}

.custom-button {
  align-items: center;
  text-align: left;
  /* margin-left: 0.75rem; */ /* 12px */
  background-color: rgb(255 255 255);
  /* box-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color); */
  /* --tw-ring-color: rgb(15 23 42); */
  color: rgb(148 163 184);
  border-radius: 0.5rem; /* 8px */
  width: 18rem; /* 288px */
  min-height: 3rem; /* 48px */
  padding-left: 1rem; /* 16px */
  padding-right: 1rem; /* 16px */
}

.custom-msg {
  text-align: center;
  color: var(--ai12z-font-mute);
  justify-content: center;
  padding: 2.5rem; /* 40px */
  max-width: 100ch !important;
}

/*Added the searchResult.tsx css*/

.cta-search-results {
  border-top-width: 1px;
  border-bottom-width: 0px;
  border-color: rgb(243 244 246);
}

.cta-search-results-list {
  position: relative;
  padding-bottom: 1.25rem;
  padding-top: 1.25rem;
}

.cta-search-results-list:hover {
  background-color: var(--ai12z-hover-bg-color);
}

.cta-search-container {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  max-width: 56rem;
  justify-content: space-between;
  column-gap: 1.5rem;
}

.cta-search-container-two {
  display: flex;
  min-width: 0px;
  column-gap: 1rem;
}

.cta-search-container-three {
  min-width: 0px;
  flex: 1 1 auto;
}

.cta-search-text {
  font-weight: 600;
  line-height: 1.5rem;
  font-size: var(--ai12z-search-result-title-font-size);
  color: var(--ai12z-search-result-title-color);
}

.cta-search-text-position {
  position: absolute;
  left: 0px;
  right: 0px;
  top: -1px;
  bottom: 0px;
}

.cta-search-description {
  margin-top: 0.25rem;
  display: flex;
  font-size: var(--ai12z-search-result-description-font-size);
  /* font-size: 0.75rem; 12px */
  line-height: 1rem; /* 16px */
  line-height: 1.25rem;
  color: var(--ai12z-search-result-description-color);
}

.cta-search-list-arrow {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  column-gap: 1rem;
}

.custom-icon-width {
  width: 4rem;
}
.results-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
